import type { IconProps } from './types';

export const EditIcon = (props: IconProps) => {
  const {
    size = 18,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g clip-path="url(#clip0_178_94)">
        <path
          d="M2.23077 10.8462L1 17L7.15385 15.7692L16.6394 6.28356C17.1201 5.80292 17.1201 5.02363 16.6394 4.54299L13.4569 1.36048C12.9762 0.879839 12.197 0.879839 11.7163 1.36048L2.23077 10.8462Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <line x1="9.53033" y1="4.46967" x2="13.5303" y2="8.46967" stroke={color} stroke-width="1.5" />
      </g>
      <defs>
        <clipPath id="clip0_178_94">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
